import {
  SANS_3,
  TextInput,
  ellipsis,
  getVal,
} from "oolib";
import React, { useRef } from "react";
import styled from "styled-components";
import { genCleanCamelCaseId } from "../../../../utils/general";


const STYLED_SANS_3 = styled(SANS_3)`
  ${ellipsis}
`;

export const TextToIDInput = ({
  id,
  value,
  onChange,
  prefix,
  hideFieldID=false,
  lockIDDisplay, // this is useful in some cases like in InitTplSettingsModal, wherein, in 'edit' mode, we do not want the ID to change even if the text in the textinput is changed
  idValuePath, // if set, the ID caption shows the ACTUAL stored id at this path on `content` (e.g a frozen option value code), and only falls back to the generated preview if nothing is stored there yet. (see modMetaConfForSomeSpecialBlocks, which injects this for the TCI options repeaters)
  content, // the parent resource this input writes into (blockGenerators pass it to every comp; in a Repeater this is the repeat item, e.g the option object)
  ...restOfProps
}) => {

  const initValue = useRef(value);

  const actualStoredId = (idValuePath && content) ? getVal(content, idValuePath) : undefined;

  return (
    <div id={id}>
      <TextInput
        id={`${id}_textInput`}
        {...restOfProps}
        value={value}
        onChange={(k, v) => onChange(id, v)}
      />
      {(value && !hideFieldID) && (
        <STYLED_SANS_3 style={{ paddingTop: "0.5rem" }} italic>
          {`${prefix || "ID: "}`}
          <span>'{actualStoredId ?? genCleanCamelCaseId(lockIDDisplay ? initValue.current : value)}'</span>
        </STYLED_SANS_3>
      )}
    </div>
  );
};
